export default __webpack_public_path__ + "static/media/tarsBackground.f3102e85.svg";